import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactListEmpty = ({ 
  hasSearchQuery = false,
  searchQuery = '',
  hasFilters = false,
  onClearFilters,
  onAddContact,
  className = ''
}) => {
  const navigate = useNavigate();

  if (hasSearchQuery || hasFilters) {
    return (
      <div className={`flex flex-col items-center justify-center py-16 px-4 ${className}`}>
        <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mb-6">
          <Icon name="Search" size={32} className="text-text-secondary" />
        </div>
        
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          No contacts found
        </h3>
        
        <p className="text-text-secondary text-center mb-6 max-w-md">
          {hasSearchQuery 
            ? `No contacts match "${searchQuery}". Try adjusting your search terms.`
            : "No contacts match your current filters. Try adjusting your filter criteria."
          }
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3">
          {hasFilters && (
            <Button
              variant="outline"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Clear Filters
            </Button>
          )}
          
          <Button
            variant="default"
            onClick={() => navigate('/add-edit-contact')}
            iconName="Plus"
            iconPosition="left"
          >
            Add New Contact
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center py-16 px-4 ${className}`}>
      <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mb-6">
        <Icon name="Users" size={32} className="text-primary" />
      </div>
      
      <h3 className="text-xl font-semibold text-text-primary mb-2">
        No contacts yet
      </h3>
      
      <p className="text-text-secondary text-center mb-6 max-w-md">
        Start building your contact list by adding your first contact. You can add contacts manually or import them from a CSV file.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          onClick={() => navigate('/add-edit-contact')}
          iconName="Plus"
          iconPosition="left"
        >
          Add First Contact
        </Button>
        
        <Button
          variant="outline"
          onClick={() => {}}
          iconName="Upload"
          iconPosition="left"
        >
          Import Contacts
        </Button>
      </div>
      
      <div className="mt-8 text-center">
        <p className="text-sm text-text-secondary mb-4">
          Quick tips to get started:
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-2xl">
          <div className="flex items-center space-x-3 p-3 bg-surface rounded-lg border border-border">
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="UserPlus" size={16} className="text-success" />
            </div>
            <div className="text-left">
              <p className="text-sm font-medium text-text-primary">Add manually</p>
              <p className="text-xs text-text-secondary">Enter contact details</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-surface rounded-lg border border-border">
            <div className="w-8 h-8 bg-accent/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Upload" size={16} className="text-accent" />
            </div>
            <div className="text-left">
              <p className="text-sm font-medium text-text-primary">Import CSV</p>
              <p className="text-xs text-text-secondary">Bulk import contacts</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-surface rounded-lg border border-border">
            <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Calendar" size={16} className="text-primary" />
            </div>
            <div className="text-left">
              <p className="text-sm font-medium text-text-primary">Set birthdays</p>
              <p className="text-xs text-text-secondary">Never miss a birthday</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactListEmpty;